import '@/index.css'
import vista_logo from "@/assets/images/Vista_logo.jpg"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';
import { useCookieConsent } from '@/hooks/useCookieConsent';

const Footer = () => {
    const { resetConsent, hasUserMadeChoice } = useCookieConsent();

    return (
        <footer className="bg-custom-darkblue text-white px-4 lg:px-6 py-10">
            <div className="footer max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8">

                {/* Social Links */}
                <nav className="space-y-2">
                <header className="footer-title">Connect With Us</header>

                <a 
                    href="https://www.facebook.com/share/1Ba8y68VuQ/?mibextid=wwXIfr" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="link link-hover flex items-center gap-2 group"
                >
                    <span className="transition-colors text-white group-hover:text-[#1877F2]">
                    <FontAwesomeIcon icon={faFacebook} size="lg" />
                    </span>
                    <span className="transition-colors group-hover:text-[#1877F2]">Facebook</span>
                </a>

                <a 
                    href="https://www.instagram.com/sheelwaterproofing07?igsh=MWljM3lucDhhanY1MA%3D%3D&utm_source=qr" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="link link-hover flex items-center gap-2 group"
                >
                    <span className="transition-colors text-white group-hover:text-[#E4405F]">
                    <FontAwesomeIcon icon={faInstagram} size="lg" />
                    </span>
                    <span className="transition-colors group-hover:text-[#E4405F]">Instagram</span>
                </a>

                <a 
                    href="https://www.linkedin.com/company/sheel-waterproofing/" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="link link-hover flex items-center gap-2 group"
                >
                    <span className="transition-colors text-white group-hover:text-[#0A66C2]">
                    <FontAwesomeIcon icon={faLinkedin} size="lg" />
                    </span>
                    <span className="transition-colors group-hover:text-[#0A66C2]">LinkedIn</span>
                </a>
                </nav>


                {/* Company */}
                <nav className="space-y-2">
                    <header className="footer-title">Company</header>
                    
                    <Link to="/about" className="link link-hover hover:text-custom-hov flex items-center gap-2">
                        About us
                    </Link>
                    
                    <Link to="/contact" className="link link-hover hover:text-custom-hov flex items-center gap-2">
                        Contact
                    </Link>
                    
                    <div className="flex items-center gap-2 hover:text-custom-hov">
                        <FontAwesomeIcon icon={faPhone} />
                        <a href="tel:01-5384509" className="tracking-wide">01-5384509</a>
                    </div>
                    
                    <div className="flex items-center gap-2 hover:text-custom-hov">
                        <FontAwesomeIcon icon={faEnvelope} />
                        <a
                            href="mailto:sheelwaterproofing1@gmail.com"
                            className="tracking-wide"
                        >
                            sheelwaterproofing1@gmail.com
                        </a>
                    </div>
                </nav>

                {/* Legal Links */}
                <nav className="space-y-2">
                    <header className="footer-title">Legal</header>
                    <Link to="/terms" className="link link-hover hover:text-custom-hov">Terms of Use</Link>
                    <Link to="/privacy-policy" className="link link-hover hover:text-custom-hov">Privacy policy</Link>
                    <Link to="/cookie-policy" className="link link-hover hover:text-custom-hov">Cookie Policy</Link>
                    {hasUserMadeChoice() && (
                        <button 
                            onClick={resetConsent}
                            className="link link-hover hover:text-custom-hov text-left"
                        >
                            Manage Cookies
                        </button>
                    )}
                </nav>

                {/* Partner Brand */}
                <nav className="w-full break-words max-w-full">
                    <header className="footer-title">Our Product Partner</header>
                    <figure className="mt-2 flex flex-col items-start sm:text-xs sm:py-0">
                        <img
                            src={vista_logo}
                            className="partner-logo"
                            alt="Vista Chemtech Logo"
                        />
                        <div className="mt-3 text-white break-words">
                            <a
                                href="https://vistachemtech.com/" 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                className="link link-hover hover:text-custom-hov flex items-center gap-2 group"
                            >
                            Vista Chemtech</a>
                            </div>
                    </figure>
                </nav>
            </div>
        </footer>    
    );
};

export default Footer;
